const internalSiteDomain = process.env.REACT_APP_USHG_INTERNAL_BASE_URL;
export const INTERNAL_SITE_ROUTES = {
  LOGIN: `${internalSiteDomain}/auth/login`,
  REGISTRATION: `${internalSiteDomain}/auth/register/pricing`,
  SUBSCRIPTION: `${internalSiteDomain}/auth/register/subscription`,
  INDIVIDUAL: `${internalSiteDomain}/auth/register/individual`,
} as const;
